// eslint-disable-next-line no-restricted-imports
import { initLogger } from '@forto-dev/frontend-infra-logger'
import { config } from 'app/config'

// ts-prune-ignore-next
export const { logDebug, logInfo, logWarn, logError } = initLogger({
  logLevel: config.LOG_LEVEL,
  enableExternalCapture: config.env === 'production',
})
